/**
 * The crosstab under the Weighted claims switch: each cell's claims plus its Σ(weight − 1)
 * from /api/weights (`cells`, keyed by employee, claim department, state, payer type and
 * facility — the bundle's own crosstab keys). Labor is untouched.
 *
 * FOR THE BREAKDOWNS ONLY — the Overview's state, payer type and facility bars, the
 * slice weights behind its trend, and a person's facilities. Never hydrate it: hydrate
 * reads a 0-claim row as labor that landed on no claim, and a cell whose claims are all
 * excluded weighs 0 without being unattributed.
 */
import type { CrosstabDict } from './types'

/** Must match api/shared/claimWeights.ts CELL_SEP. */
export const CELL_SEP = '\u001f'

export function weightCrosstab(ct: CrosstabDict, cells: Readonly<Record<string, number>>): CrosstabDict {
  return {
    ...ct,
    rows: ct.rows.map((r) => {
      const key = [
        ct.employees[r[0]],
        ct.departments[r[1]],
        ct.states[r[2]],
        ct.payers[r[3]],
        ct.facilities[r[5]],
      ].join(CELL_SEP)
      const adj = cells[key]
      if (adj === undefined) return r
      // Claim detail is a subset of the crosstab's claims, so this never goes below 0;
      // the floor only guards a bundle and claim rows from different builds.
      return [r[0], r[1], r[2], r[3], r[4], r[5], Math.max(0, r[6] + adj), r[7]]
    }),
  }
}
